<template>
  <div>
    <div class="searchBox">
      <div class="searchLeft">
        <el-select size="medium" clearable v-model="searchForm.status" @change="getTableList" placeholder="请选择状态">
          <el-option label="待分币" value="1"></el-option>
          <el-option label="已分币" value="3"></el-option>
        </el-select>
        <el-date-picker
          @change="getTableList"
          size="medium"
          v-model="searchForm.incomeDate"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsStart"
          placeholder="请选择查询时间">
        </el-date-picker>
      </div>
    </div>
    <el-table :data="tableData" height="73vh" border style="width: 100%">
      <el-table-column prop="incomeDate" label="分币日期" width="110px"></el-table-column>
      <el-table-column prop="nodeNumber" width="100px" label="节点号"></el-table-column>
      <el-table-column prop="coinStart" width="140px" label="0点累计出块奖励">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.coinStart,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coinEnd" label="24点累计出块奖励" align="center" width="160px">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.coinEnd,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="110px"
        prop="luckyValue"
        label="幸运值(%)">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(Number(scope.row.luckyValue)*100,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coinIncome" width="120px" label="本次Fil收益数" align="center" >
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.coinIncome,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coinIncome" width="120px" label="本次Fil分配数" align="center" >
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential((scope.row.planAllocateFil),4)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="maxPower" label="节点算力数" align="center" width="110px">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.maxPower,4)}} TiB</span>
        </template>
      </el-table-column>
       <el-table-column prop="realUnitIncome "  label="实际单T收益" align="center" width="120px">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.realUnitIncome ,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="unitIncome"  label="单T收益" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.unitIncome,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="actTotalPower" width="120px" label="实际分配算力数" align="center" >
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.actTotalPower,4)}} TiB</span>
        </template>
      </el-table-column>
      <el-table-column prop="actTotalCoin" width="120px" label="实际FIL分配数" align="center" >
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.actTotalCoin,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="actOrderNum" width="120px" label="实际分配订单数" align="center" >
        <template slot-scope="scope">
          <span>{{scope.row.actOrderNum}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="gas" label="Gas" align="center" >
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.gas,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="burn" label="惩罚" align="center" >
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.burn,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="burn" label="历史亏欠" align="center" >
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.ownGasBurn,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="memo" label="备注" align="center" width="100"></el-table-column>
      <el-table-column prop="status" label="状态" align="center" > 
        <template slot-scope="scope">
          <span :class="scope.row.status == 1? 'active': ''">{{scope.row.status == 1 ? '待分币':scope.row.status == 2 ? '分币中': '已分币'}}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="160">
        <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="open(scope.row)" v-if="!scope.row.poolIncomeId&&scope.row.status==1&&statusType">
                <i class="el-icon-check" style="margin-right:3px;"></i>
                开始分币
            </el-button>
            <el-button size="mini" type="info" v-if="scope.row.status==1&&!statusType">
                <i class="el-icon-check" style="margin-right:3px;"></i>
                分币中...
            </el-button>
            <el-button size="mini" type="primary" @click="openModule(scope.row)" v-if="!scope.row.poolIncomeId&&scope.row.status==1">
                编辑
            </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[20, 50, 100]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="编辑分币"
      :visible.sync="dialogVisible"
      width="450px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="132px" class="demo-ruleForm">
          <el-form-item label="分币值" prop="coinIncome">
            <el-input placeholder="请输入分币值" v-model="ruleForm.coinIncome" style="width:220px" type="number"></el-input>
          </el-form-item>
          <el-form-item label="算力数" prop="maxPower">
            <el-input placeholder="请输入算力数" v-model="ruleForm.maxPower" style="width:220px" type="number"></el-input>
          </el-form-item>
          <el-form-item label="Gas" prop="gas">
            <el-input placeholder="请输入gas" v-model="ruleForm.gas" style="width:220px" type="number"></el-input>
          </el-form-item>
          <el-form-item label="惩罚值" prop="burn">
            <el-input placeholder="请输入惩罚值" v-model="ruleForm.burn" style="width:220px" type="number"></el-input>
          </el-form-item>
          <el-form-item label="单T收益" prop="unitIncome" v-if="ruleForm.unitIncomeSettings == 2">
            <el-input placeholder="请输入单T收益" v-model="ruleForm.unitIncome" style="width:220px" type="number"></el-input>
          </el-form-item>
          <el-form-item label="备注" >
            <el-input placeholder="备注" v-model="ruleForm.memo" style="width:220px" type="text" maxlength="32"></el-input>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      },
      searchForm: {
        page: 1,
        pageSize: 20,
        status: '',
        incomeDate: '',
        nodeNumber: ''
      },
      tableData: [],
      totalNum:0,
      objNum: {},
      dialogVisible: false,
      statusType: true,
      ruleForm:{
        coinIncome: '',
        maxPower: '',
        memo: '',
        nodeIncomeId: '',
        status:'',
        gas: null,
        burn: null,
        unitIncome: null,
        unitIncomeSettings: null
      },
      rules:{
        coinIncome: [
          { required: true, message: '请输入分币值', trigger: 'blur' },
        ],
        maxPower: [
          { required: true, message: '请输入算力数', trigger: 'blur' },
        ],
        gas: [
          { required: true, message: '请输入gas', trigger: 'blur' },
        ],
        burn: [
          { required: true, message: '请输入惩罚值', trigger: 'blur' },
        ],
        memo:[
          { required: true, message: '请选择修改备注', trigger: 'blur' },
          { min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur' }
        ],
        unitIncome: [
          { required: true, message: '请输入单T收益值', trigger: 'blur' },
        ]
      },
    }
  },
  created() {
    this.searchForm.nodeNumber = sessionStorage.getItem("minerCode");
    if (this.searchForm.nodeNumber) {
        this.getTableList()
    }
    
  },
  methods: {
    openModule(row) {
      this.dialogVisible = true
      this.ruleForm.nodeIncomeId = row.id,
      this.ruleForm.coinIncome = row.coinIncome
      this.ruleForm.maxPower = row.maxPower,
      this.ruleForm.burn = row.burn,
      this.ruleForm.gas = row.gas
      this.ruleForm.unitIncomeSettings = row.unitIncomeSettings
      this.ruleForm.unitIncome = row.unitIncome
    },
    submitForm(formName) {
      let _this = this
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await _this.$http.updateFil({..._this.ruleForm});
          if (res) {
            _this.$message.success('操作成功！');
            _this.dialogVisible=false;
            _this.ruleForm.coinIncome = ''
            _this.ruleForm.memo = ''
            _this.getTableList()
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    open(item) {
      this.$confirm('是否开始分币?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          this.statusType = false
          let data = {
            nodeIncomeId: item.id,
            status:2,
            coinIncome: '',
            memo: '',
            maxPower: '',
            gas: item.gas,
            burn: item.burn
          }
          let res = await this.$http.updateFil({...data})
          if (res) {
            this.statusType = true
            this.getTableList()
            this.$message({
                message: '操作成功',
                type: 'success'
            });
          } else {
            this.statusType = true
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
    },
    async getTableList (val) {
      if(val){
        this.searchForm.page=1;
      }
      let res = await this.$http.nodeHistory({...this.searchForm});
      if (res) {
        this.tableData=res.data.list
        this.totalNum=res.data.totalSize
      }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    },
  },
};
</script>

<style scoped>
.searchBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.active{
    color: red;
}
</style>
